import React from 'react';
import Framework from '@beardeddevops/react.framework';
import NavLeftList from './NavLeftList';
import NavRightList from './NavRightList';
import PropTypes from "prop-types";
import APPCONFIG from "constants/Config";
import {Link} from "react-router-dom";

class Header extends React.Component {
	static propTypes = {
		headerModals: PropTypes.any,
		scannedCode: PropTypes.any
	};

	render() {
		let {rootState} = this.props;

		return (
			<Framework.Elements.Header
				rootState={rootState}
				shouldShowBrand={!rootState.kioskMode}
				brandLink={<Link to="/" className="brand">
					{this.props.isAdmin ? 'FFL Boss Admin' : APPCONFIG.brand}
				</Link>}
				shouldShowLeftNav={!rootState.kioskMode}
				navLeft={<NavLeftList headerModals={this.props.headerModals} scannedCode={this.props.scannedCode}/>}
				navRight={<NavRightList />}
			/>
		)
	}
}

export default Header = Framework.Components.withRootState(Header);